import {FormioBase} from "./formiobase";

export class Radio extends FormioBase {
  public inputType = "radio";
  public title = "Radio";
  public icon = "far fa-dot-circle";
  public schema: any = {
    title: "radio",
    components: [{
      input: true,
      tableView: true,
      inputType: "radio",
      label: "",
      key: "",
      values: [{
        label: "Example Select",
        value: "ExampleSelect",
      }],
      defaultValue: "",
      protected: false,
      persistent: true,
      clearOnHide: true,
      validate: {
        required: false,
        custom: "",
        customPrivate: false,
      },
      type: "radio",
      inline: true,
      tags: [],
      description: "",
      tooltip: "",
      customClass: "ds-radio",
    }],
  };
}
